import request from '@u/request'
/**
 * 生涯学院接口文件
 * @param {*} data 
 */
// 上传图片
export function upload_image(data){
	return request({
		headers:{
			'Content-Type':'application/x-www-form-urlencoded'
		},
		url: '/cms/upload_image',
		method: 'POST',
		data: data || {}
	})
}

/*
 *@param: 
 *@return: 
 *@Description: 渠道管理接口
 *@MethodAuthor:  Zhang Xiao Guang
 *@Date: 2020-03-06 11:17:21
*/
// 渠道列表
export function sourceList(data){
	return request({
		url: '/cms_track/sourceList',
		method: 'POST',
		data: data || {}
	})
}

// 全部渠道
export function sourceAll(data){
	return request({
		url: '/cms_track/sourceAll',
		method: 'POST',
		data: data || {}
	})
}

// 添加渠道
export function addSource(data){
	return request({
		url: '/cms_track/addSource',
		method: 'POST',
		data: data || {}
	})
}

// 修改渠道
export function updateSource(data){
	return request({
		url: '/cms_track/updateSource',
		method: 'POST',
		data: data || {}
	})
}

// 修改状态
export function setSourceStatus(data){
	return request({
		url: '/cms_track/setSourceStatus',
		method: 'POST',
		data: data || {}
	})
}

// 获取渠道数据
export function getSource(data){
	return request({
		url: '/cms_track/getSource',
		method: 'POST',
		data: data || {}
	})
}

// 活动列表
export function activityList(data){
	return request({
		url: '/cms_track/activityList',
		method: 'POST',
		data: data || {}
	})
}

// 添加活动
export function addActivity(data){
	return request({
		url: '/cms_track/addActivity',
		method: 'POST',
		data: data || {}
	})
}

// 修改活动
export function updateActivity(data){
	return request({
		url: '/cms_track/updateActivity',
		method: 'POST',
		data: data || {}
	})
}

// 获取活动数据
export function getActivity(data){
	return request({
		url: '/cms_track/getActivity',
		method: 'POST',
		data: data || {}
	})
}

// 获取二维码地址
export function getBaseUrl(data){
	return request({
		url: '/cms_track/getBaseUrl',
		method: 'POST',
		data: data || {}
	})
}

// 表单列表
export function tableList(data){
	return request({
		url: '/cms_form/tableList',
		method: 'POST',
		data: data || {}
	})
}

// 数据列表
export function dataList(data){
	return request({
		url: '/cms_form/dataList',
		method: 'POST',
		data: data || {}
	})
}

// 数据导出
export function dataAll(data){
	return request({
		url: '/cms_form/dataAll',
		method: 'POST',
		data: data || {}
	})
}